var CONFUSEDWEBSITE = CONFUSEDWEBSITE || {};

(function ($) {
    $(function () {

        CONFUSEDWEBSITE.setupGlobalNav();
        CONFUSEDWEBSITE.skipNav();

        if ($('.mobile-nav').length > 0) {
            CONFUSEDWEBSITE.activateMobileNav();
        }

        CONFUSEDWEBSITE.setupHeaderActions();
        CONFUSEDWEBSITE.setupSearchResults();
        CONFUSEDWEBSITE.setupSearchForms();

    });

})(window.jQuery);